import { EmploymentDetailsFormModel_MX } from './formModel';

export const getInitialValues = (): EmploymentDetailsFormModel_MX => {
  return {
    employmentStatus: undefined,
    occupation: undefined,
    employer: '',
    occupationNotes: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    eirCode: '',
    town: '',
    county: '',
    timeWithEmployerFrom: '',
    timeWithEmployerTo: '',
    netMonthlyIncome: 0,
    netOtherMonthlyIncome: 0,
  };
};
